import React from 'react'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { Text } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
import './ToggleIdModal.css'

class ToggleIdModal extends React.Component {

  state = {
    showItem: false,
  }

  handleDropdown = e => {
    this.setState(prevState => {
      return {
        showItem: !prevState.showItem
      }
    })
  }


  render(){
    return (
      <div className="Toggle-id-modal" style={{ display: this.props.ids.length === 1 && 'inline-block'}}>
        <div className="Toggle-id-modal-item">

          {this.props.ids.length === 1

            ? this.props.ids.map((itm, idx) => (
                <a className={`is-one-item ${this.props.noBackground ? 'no-background' : ''}`} key={idx} onClick={e => this.props.app.toggleModal(e, 'contract-id', itm)}>{itm.id}</a>
              ))

            : <div>
                <div className="has-multiple-items" onClick={this.handleDropdown}>
                  <Text>{translate('app.toggleIdModalLabel')}</Text>
                </div>
                <div className="is-aligned-column">
                  {this.props.ids.map((itm, idx) => (
                    this.state.showItem &&
                      <a className="is-one-item" key={idx} onClick={e => this.props.app.toggleModal(e, 'contract-id', itm)}>{itm.id}</a>
                  ))}
                </div>
              </div>
          }

        </div>
      </div>
    )
  }
}

export default withApp(ToggleIdModal)
